import { Component, OnInit } from "@angular/core";
import { Banners } from "./banners.interface";
import { GetBannersAction } from "./banners.actions";
import { Store } from "@ngrx/store";
import { getBannersSelector } from "./banners.reducer";
import { MatDialog } from "@angular/material/dialog";
import { BannerAddComponent } from "./banner-add/banner-add.component";

@Component({
  selector: "app-banners",
  templateUrl: "./banners.component.html",
  styleUrls: ["./banners.component.scss"],
  standalone: false,
})
export class BannersComponent implements OnInit {
  banners: Banners;

  constructor(
    private store: Store,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new GetBannersAction());

    this.store.select(getBannersSelector).subscribe((banners: Banners) => {
      this.banners = banners;
    });
  }

  showAddForm(): void {
    this.dialog.open(BannerAddComponent, {
      width: "600px",
      maxHeight: "calc(100vh - 48px)",
      panelClass: "app-dialog-panel",
    });
  }
}
